import React, { Component } from "react";
import swal from "sweetalert";
import ModalVideo from "react-modal-video";
import Tooltip from "@material-ui/core/Tooltip";
import LayersIcon from "@material-ui/icons/Layers";
import { Navbar, Button, Dropdown, OverlayTrigger, Tooltip as ReactBootstrapTooltip } from "react-bootstrap";
import { TfiHelp, TfiBook, TfiSettings } from "react-icons/tfi";
import { PiQueue, PiSparkleBold, PiMegaphone } from "react-icons/pi";
import AccessibilityNewSharpIcon from "@material-ui/icons/AccessibilityNewSharp";
import PowerSettingsNewSharpIcon from "@material-ui/icons/PowerSettingsNewSharp";
import SupervisorAccountSharpIcon from "@material-ui/icons/SupervisorAccountSharp";
import axios from '../../axios';
import apiError from '../../error';
import { getCookie } from "../../function";
import swalAlert from "../../swalFunction";
import HeaderRightImg from "../../assets/logoright.png";
import Language from "../../component/language/language";
import LaunchNewModal from "../../component/launch-modal/launch-new-modal";
import SupportModal from "../../component/support-modal/support-modal";
import NewConnectModal from "../../component/connect-ta-modal/new-connect-ta-modal";
import VersionHistoryModal from "../../component/version-history";
import "./header.css";
import "react-modal-video/css/modal-video.min.css";
import { TfiBlackboard } from "react-icons/tfi";

export default class Header extends Component {
	constructor(props) {
		super(props);
		this.isTAconnected = getCookie('isTAconnected');
		this.isTASyncing = getCookie('isTASyncing');
		this.state = {
			videoId: 0,
			isOpen: false,
			showModal: false,
			supportModal: false,
			newshowModal: false,
			showVersionHistoryModal: false,
			videoIds: ["BzJHCCEY6FA"],
			userType: getCookie("userType"),
			billingType: getCookie("billingType"),
			permissibleActionsIAM: {}
		}
	}


	// New Connect Modal

	newhandleModal = (status) => {
		this.setState({ newshowModal: status });
	};

	handleClose = () => {
		this.setState({ showModal: false });
	};


	componentDidMount() {
		this.loadPermissibleActions();
		this.loadStorylaneScript();
	}

	loadStorylaneScript = () => {
		if (document.getElementById("storylane-script")) return;
		const script = document.createElement("script");
		script.id = "storylane-script";
		script.async = true;
		script.src = "https://js.storylane.io/js/v2/storylane.js";
		script.setAttribute("data-verify-origin", "");
		document.body.appendChild(script);
	};

	handleProductTour = () => {
		if (window.Storylane) {
			window.Storylane.Play({
				type: "popup",
				demo_type: "image",
				width: 2940,
				height: 1684,
				scale: "0.95",
				demo_url: "https://app.storylane.io/demo/y3urx8dnldvv?embed=popup",
				padding_bottom: "calc(57.28% + 25px)"
			});
		}
	};

	openModal = (videoId) => {
		this.setState({ isOpen: true, videoId: videoId });
	};

	showHandle = () => {
		this.setState({ showModal: !this.state.showModal });
	};
	supportHandle = () => {
		this.setState({ supportModal: !this.state.supportModal });
	};

	handleLogout = () => {
		swal({
			title: "Are you sure you want to logout?",
			icon: "info",
			buttons: ["Not Now!", "Yes"],
		})
			.then((willSuccess) => {
				if (willSuccess) {
					this.props.nextPath("/logout");
				}
			});
	};

	handlePartner = () => {
		window.open("https://threatcop.com/partnership-overview");
	};

	handleChangeLog = () => {
		window.open("/change-log");
	};

	handleVersionHistoryModal = (status) => {
		this.setState({ showVersionHistoryModal: status });
	};

	handleLMS = async () => {
		document.body.style.cursor = "wait";
		axios.get('/api/lms', {
			params: {
				switch: true
			}
		})
			.then(res => {
				document.body.style.cursor = "";
				const allowedBaseURL = process.env.REACT_APP_LMS_URL;
				const allowedDomain = new URL(allowedBaseURL).hostname;
				const url = new URL(res.data.url);

				const allowedDomainParts = allowedDomain.split('.').slice(-2).join('.');
				const urlDomainParts = url.hostname.split('.').slice(-2).join('.');

				// Validate domain
				if (urlDomainParts !== allowedDomainParts) {
					swalAlert("Security Alert", "Invalid redirect URL detected!", "error");
					return;
				}

				// Prevent Open Redirection
				const redirectUrl = url.searchParams.get("url"); // Potential redirection target
				if (redirectUrl) {
					try {
						const parsedRedirectUrl = new URL(redirectUrl, allowedBaseURL); // Resolve relative paths
						const redirectDomainParts = parsedRedirectUrl.hostname.split('.').slice(-2).join('.');

						if (redirectDomainParts !== allowedDomainParts) {
							swalAlert("Security Alert", "Invalid redirect target detected!", "error");
							return;
						}
					} catch (error) {
						console.log("Invalid redirect URL detected:", error);
						swalAlert("Security Alert", "Invalid redirect target detected!", "error");
						return;
					}
				}
				window.open(res.data.url, '_blank');
			})
			.catch(err => {
				document.body.style.cursor = "";
				if (err.response?.data?.errors[0] === "TLMS_CONNECTED_TO_THREATCOP_ADMIN") {
					swalAlert("TLMS connected to Threatcop Admin", "This function has been terminated. Please connect TSAT with Threatcop Admin and manage TSAT/TLMS accordingly.", "error");
					return;
				}
				apiError(err);
			});
	}
	loadPermissibleActions = async () => {
		try {
			let permissibleActions = await axios.post('/api/iam-user/permissions', {
				actions: ['campaign-write', 'setting-read', 'user-and-department-read', 'campaign-template-read']
			});
			this.setState({ permissibleActionsIAM: permissibleActions.data.permissibleObj });
		} catch (error) {
			console.log("Error occured while fetching permissibleActionsIAM: ", error);
		}
	}

	nextPath = (path) => {
		const pathWithQuery = path + (path.indexOf('?') !== -1 ? '&' : '?') + 'from=campaign';
		if (this.props.nextPath) {
			this.props.nextPath(pathWithQuery);
		}
	}

	render() {
		const firstNameRaw = getCookie("firstname") || "";
		const displayInitial = firstNameRaw.trim()
			? firstNameRaw.trim()[0].toUpperCase()
			: "?";
		const logoCookieRaw = getCookie("logo") || "";
		const logoCookie = logoCookieRaw.trim();

		return (
			<div>


				<Navbar className="bg-light justify-content-between header" fixed="top">
					<OverlayTrigger
						placement="bottom"
						overlay={
							!this.state.permissibleActionsIAM['campaign-write']
								? (<ReactBootstrapTooltip id="header-create-campaign-perm">You don't have permission to access</ReactBootstrapTooltip>)
								: (
									(!this.state.permissibleActionsIAM['user-and-department-read'] || !this.state.permissibleActionsIAM['campaign-template-read']) ? (
										<ReactBootstrapTooltip id="header-create-campaign-deps">You need user-and-department-read and campaign-template-read policy along with campaign-create to access this</ReactBootstrapTooltip>
									) : (
										<ReactBootstrapTooltip id="header-create-campaign" className="d-none"></ReactBootstrapTooltip>
									)
								)
						}
					>
						<Button
							variant="primary"
							onClick={() =>
								this.state.permissibleActionsIAM['campaign-write'] &&
								this.state.permissibleActionsIAM['user-and-department-read'] &&
								this.state.permissibleActionsIAM['campaign-template-read'] &&
								this.showHandle()
							}
							className="header-create-campaign-btn"
						>
							<PiMegaphone className="btn-icon" />
							<span className="btn-text">Create Campaign</span>
						</Button>
					</OverlayTrigger>

					<div
						className={
							logoCookie
								? "d-flex align-items-center remove-translate"
								: "d-flex align-items-center remove-translate header1"
						}
					>

						<div className="left-side-cta me-2">
							<a className='ai-threatcop-btn' onClick={() => this.props.nextPath("/awareness-manager")}>
								<PiSparkleBold className="mr-1" />Threatcop AI
							</a>
						</div>

						<div>
							<button variant="primary" className="product_tour" onClick={this.handleProductTour}> <TfiBlackboard className="mr-1" /> Product Tour</button>
						</div>
						<Tooltip title="Language" placement="bottom">
							<div className="MidLanguage header-language-slot">
								<Language />
							</div>
						</Tooltip>




						<Dropdown className="user-dropdown LmsRightBtn d-inline-block">
							{!this.isTAconnected &&
								<Tooltip title="Switch to TLMS Product" placement="bottom">
									<Dropdown.Toggle id="dropdown-basic" className="comp-dropdown" onClick={this.handleLMS}>
										<img
											src={HeaderRightImg}
											alt=""
											className="leftcompImg"
											style={{ height: "25px" }}
										></img>
										<span className="LmsLogobtnCont">TSAT</span>
									</Dropdown.Toggle>
								</Tooltip>
							}

							{/* <Dropdown.Menu className="RightLogin">
								<Dropdown.Header>Switch Product</Dropdown.Header>
								<Dropdown.Divider />

								<Dropdown.Item onClick={this.handleLMS}>
									<img src={HeaderRightImg} className="btn-icon" alt="abc"></img>TLMS
								</Dropdown.Item>

								<Dropdown.Divider />
							</Dropdown.Menu> */}
						</Dropdown>


						<div className="Midinfobar">
							<Tooltip title="Guide" placement="bottom">
								<Button
									className="round-btn"
									onClick={() => this.props.nextPath("/product-guide")}
								>
									<TfiBook></TfiBook>
								</Button>
							</Tooltip>
						</div>
						<div className="Midinfobar">
							<Tooltip title="Help" placement="bottom">
								<Button
									className="round-btn"
									onClick={() =>
										this.setState({ supportModal: !this.state.supportModal })
									}
								>
									<TfiHelp></TfiHelp>
								</Button>
							</Tooltip>
						</div>
						<OverlayTrigger
							placement="bottom"
							overlay={
								!this.state.permissibleActionsIAM['setting-read']
									? (<ReactBootstrapTooltip id="bottom">You don't have permission to access</ReactBootstrapTooltip>)
									: (<ReactBootstrapTooltip id="bottom">Settings</ReactBootstrapTooltip>)
							}
						>
							<div className="Midinfobar">
								<Button
									className="round-btn"
									onClick={() => this.state.permissibleActionsIAM['setting-read'] && this.props.nextPath("/settings")}>
									<TfiSettings></TfiSettings>
								</Button>
							</div>

						</OverlayTrigger>

						<Dropdown className="user-dropdown d-inline-block">
							<Dropdown.Toggle
								id="dropdown-basic"
								className="comp-dropdown header-user-trigger"
								aria-label={firstNameRaw.trim() ? `Account menu for ${firstNameRaw.trim()}` : "Account menu"}
							>
								<span className="header-user-trigger__inner">
									{logoCookie ? (
										<img
											src={logoCookie}
											alt=""
											className="comp-logo header-user-trigger__logo"
										/>
									) : null}
									<div className="user-icon header-user-avatar">
										<span className="header-user-avatar__letter">{displayInitial}</span>
									</div>
								</span>
							</Dropdown.Toggle>
							<Dropdown.Menu className="RightLogin dropdown-menu-end dropdown-menu-right">
								<Tooltip title={getCookie("firstname")} placement="bottom">
									<Dropdown.Header>
										Hi, {(getCookie("firstname") || "").substring(0, 10)}
									</Dropdown.Header>
								</Tooltip>
								{/* {this.state.billingType === "Threatcop" &&
									this.state.userType === "root" ? (
									<>
										<Dropdown.Divider />
										<Dropdown.Item
											onClick={() => this.props.nextPath("/iam/users")}
										>
											<AccessibilityNewSharpIcon className="btn-icon"></AccessibilityNewSharpIcon>
											IAM
										</Dropdown.Item>
									</>
								) : null} */}
								{/* <Dropdown.Item onClick={this.handlePartner}>
									<SupervisorAccountSharpIcon className="btn-icon"></SupervisorAccountSharpIcon>
									Partner with us
								</Dropdown.Item>
								<Dropdown.Divider /> */}

								<Dropdown.Item
									onClick={() => this.props.nextPath("/audit-logs")}
								>
									<LayersIcon className="btn-icon"></LayersIcon>Activity Logs
								</Dropdown.Item>
								{/* <Dropdown.Item onClick={this.handleChangeLog}>
									<LayersIcon className="btn-icon"></LayersIcon>Change Logs
								</Dropdown.Item> */}
								<Dropdown.Item onClick={() => this.handleVersionHistoryModal(true)}>
									<LayersIcon className="btn-icon"></LayersIcon>Version History
								</Dropdown.Item>
								{getCookie('devAgent') && (
									<>

										<Dropdown.Item
											as="button"
											type="button"
											className="dropdown-item-dev-bull"
											onClick={() => window.open(`${process.env.REACT_APP_API_URL}/bull-board`, '_blank')}
										>
											<PiQueue className="btn-icon dropdown-dev-bull-icon" />
											Bull MQ Dashboard
										</Dropdown.Item>
									</>
								)}
								<Dropdown.Item onClick={this.handleLogout}>
									<PowerSettingsNewSharpIcon className="btn-icon"></PowerSettingsNewSharpIcon>
									Logout
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					</div>
				</Navbar>
				<LaunchNewModal
					showModal={this.state.showModal}
					showHandle={this.showHandle}
					nextPath={this.nextPath}
				/>
				<SupportModal
					supportModal={this.state.supportModal}
					supportHandle={this.supportHandle}
					openModal={this.openModal}
				></SupportModal>
				<React.Fragment>
					<ModalVideo
						channel="youtube"
						isOpen={this.state.isOpen}
						videoId={this.state.videoIds[this.state.videoId]}
						onClose={() => this.setState({ isOpen: false })}
					/>
				</React.Fragment>

				<NewConnectModal
					show={this.state.newshowModal}
					handleModal={this.newhandleModal}
					handleClose={this.newhandleClose}
				/>
				<VersionHistoryModal
					show={this.state.showVersionHistoryModal}
					handleModal={this.handleVersionHistoryModal}
				/>
			</div>

		);
	}
}
